exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._1HjqjemGAiqgYVitw10m7l{text-align:center;margin-top:40px;height:70px;font-size:14px;margin-bottom:10px;padding:0 20px;width:100%}._1QBj6QbKvVbgMlkGlomxw7{font-size:30px;margin-bottom:20px;font-weight:100}", "", {"version":3,"sources":["/Users/mrodrigo/Documents/DEV/v2APP/src/components/templates/Event/ListAttachments/style.css"],"names":[],"mappings":"AAAA,yBACI,kBAAmB,AACnB,gBAAiB,AACjB,YAAa,AACb,eAAgB,AAChB,mBAAoB,AACpB,eAAgB,AAChB,UAAY,CACf,AACD,yBACI,eAAgB,AAChB,mBAAoB,AACpB,eAAiB,CACpB","file":"style.css","sourcesContent":[".description {\n    text-align: center;\n    margin-top: 40px;\n    height: 70px;\n    font-size: 14px;\n    margin-bottom: 10px;\n    padding: 0 20px;\n    width: 100%;\n}\n.title {\n    font-size: 30px;\n    margin-bottom: 20px;\n    font-weight: 100;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"description": "_1HjqjemGAiqgYVitw10m7l",
	"title": "_1QBj6QbKvVbgMlkGlomxw7"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/templates/Event/ListAttachments/style.css
// module id = 1005
// module chunks = 0 1 2 3